module.exports = __webpack_public_path__ + "static/media/aspire.04f0a236.png";